
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility-relocate/[id]",
      function () {
        return require("private-next-pages/facility-relocate/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facility-relocate/[id]"])
      });
    }
  